import { render, staticRenderFns } from "./chart-profit-container.vue?vue&type=template&id=3c066022&scoped=true&"
import script from "./chart-profit-container.vue?vue&type=script&lang=js&"
export * from "./chart-profit-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c066022",
  null
  
)

export default component.exports